
import { Box, Button, Stack, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import QuestionnaireFormSection from "../../../components/Questionnaire/QuestionFormView/QuestionnaireFormSection";
import { addOrUpdateQuestionnaireAnswer } from "../../../apis/questionnaireApis";
import { debounce, history, QuestionnaireItemType } from "../../../_helpers";
import { questionnaireDetailActions } from "../../../_actions";

const QuestionnaireFormView = ({
  canEditQuestionnaire,
  validateSection,
  handleFiles,
  section,
  formData,
  setFormData,
  formValues,
  setFormValues,
  errors,
  setErrors
}
) => {
  const { questionnaireStore: { questionnaireDetails: { questionnaireDetails, currantSectionIndex } } } = useSelector(state => state);
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const theme = useTheme()
  const totalSections = questionnaireDetails?.sections.length;
  const isLastSection = currantSectionIndex === totalSections - 1;
  
  const handleChange = debounce(async (sectionIndex, question, value) => {
    const questionId = question.id
    let cleaned = value;

    if (typeof cleaned === "string") {
      cleaned = cleaned.trim();
    }
    setErrors(prev => {
      const updated = new Map(prev);
      const isEmpty =
        cleaned === "" ||
        cleaned === null ||
        cleaned === undefined ||
        (Array.isArray(cleaned) && cleaned.length === 0);

      if (!isEmpty) {
        updated.delete(`${sectionIndex}-${questionId}`);
      }

      return updated;
    });
    switch (question.type) {
      case QuestionnaireItemType.Radio:
      case QuestionnaireItemType.Checkbox:
      case QuestionnaireItemType.ShortText:
      case QuestionnaireItemType.Paragraph:
      case QuestionnaireItemType.Date:
      case QuestionnaireItemType.Time:
      case QuestionnaireItemType.Dropdown:
        {
          await addOrUpdateQuestionnaireAnswer({
            "questionnaireId": questionnaireDetails.id,
            "questionId": questionId,
            "answer": value,
          })
          setFormValues({
            ...formValues,
            [questionId]: value
          })
          break
        }
      case QuestionnaireItemType.Signature:
        const isTextBoxChange = Array.isArray(value)
        const answerValue = isTextBoxChange ? value : formValues?.[questionId]?.value
        const signatureValue = isTextBoxChange ? formValues?.[questionId]?.content : value.content
        await addOrUpdateQuestionnaireAnswer({
          "questionnaireId": questionnaireDetails.id,
          "questionId": questionId,
          "answer":answerValue,
          signature: {
            "content": signatureValue
          }
        });
        setFormValues({
          ...formValues,
          [questionId]: {content: signatureValue , value: answerValue }
        })
        break;
      default:
        break
    }

  }, 1000);
   
   const previewHandler = () => {
        history.push(`/vragenlijst/${questionnaireDetails?.id}/preview`);
    }

  return (
    <Box sx={{ bgcolor: theme.palette.grey[100], py: 5, minHeight: "100%", display: "flex", flexDirection: "column", alignItems: "center", opacity: canEditQuestionnaire ? 0.7 : 1, pointerEvents: canEditQuestionnaire ? "none" : "auto", }}>
      <QuestionnaireFormSection
        section={section}
        sectionIndex={currantSectionIndex}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        handleChange={handleChange}
        handleFiles={handleFiles}
      />
      <Stack direction="row" justifyContent="space-between" sx={{ width: "100%", maxWidth: 700, mt: 2 }}>
        {currantSectionIndex > 0 && (
          <Button variant="outlined" onClick={() => {
            dispatch(questionnaireDetailActions.changeSectionIndex(currantSectionIndex - 1))
            dispatch(questionnaireDetailActions.fetchQuestionnaireDetails(questionnaireDetails.id))
          }}>
            {t('general.back')}
          </Button>
        )}


        {isLastSection ?
          <Button
            variant="contained"
            onClick={() => {
              if (validateSection()) {
                setErrors({});
                previewHandler();
              }
            }}
          >
            {t('general.previewAndComplete')}
          </Button>
          :
          <Button
            variant="contained"
            onClick={() => {
              if (validateSection()) {
                setErrors({});
                dispatch(questionnaireDetailActions.changeSectionIndex(currantSectionIndex + 1));
                dispatch(questionnaireDetailActions.fetchQuestionnaireDetails(questionnaireDetails.id));
              }
            }}
          >
            {t('general.next')}
          </Button>
        }
      </Stack>
    </Box>
  );
};

export default QuestionnaireFormView;
